<app-spinner-overlay
    [showSpinner]="isSaving"
>
    <ng-container
        *ngIf="paymentDetailsFormError"
    >
        <div
            class="alert alert-danger"
            role="alert"
            data-test="payment-details-form-error"
        >
            <div class="hstack gap-2 justify-content-between">
                <div>{{ paymentDetailsFormError }}</div>
                <button
                    type="button"
                    class="btn-close m-0"
                    (click)="clearFormErrors()"
                >
                </button>
            </div>
        </div>
    </ng-container>
    <ng-container
        *ngIf="bookingSlotUnavailableWarning"
    >
        <div
            class="alert alert-warning"
            role="alert"
            data-test="booking-slot-unavailable-warning"
        >
            <div class="hstack gap-2 justify-content-between">
                <div>{{ bookingSlotUnavailableWarning }}</div>
                <button
                    type="button"
                    class="btn-close m-0"
                    (click)="clearFormErrors()"
                >
                </button>
            </div>
        </div>
    </ng-container>
    <form
        appVenueColour
        [primaryColour]="venue?.primaryColour"
        [formGroup]="form"
        [ngClass]="{'Ryft--payform': isRyftPayment}"
        class="h-100 vstack gap-3"
    >
        <div class="vstack gap-2">
            <h5
                *ngIf="showTitle"
            >
                Card Details
            </h5>
            <div class="vstack gap-2">
                <div class="vstack gap-2 rounded p-3 bg-light flex-grow-0">
                    <span class="badge bg-dark-subtle text-dark-emphasis lh-sm me-auto fw-semibold">
                        Card Details Required
                    </span>
                    <label class="text-muted">
                        We require a card to secure your booking.
                        <br/>
                        Cancellations or no-shows
                        <ng-container
                            *ngIf="cancellationChargeCutOffHours !== null"
                        >
                            with less than
                            {{ cancellationChargeCutOffHours | i18nPlural : hoursPluralMapping }}
                            notice
                        </ng-container>
                        may be charged
                        <span class="fw-bold">
                            {{ cancellationChargeAmount.toFormat() }}
                            <ng-container
                                *ngIf="cancellationChargeIsPerCover"
                            >
                                per person</ng-container></span>.
                    </label>
                </div>
                <div
                    id="payment-apple-wallet-button"
                    [hidden]="!walletPaymentAvailable"
                >
                </div>
                <div
                    id="payment-google-wallet-button"
                    [hidden]="!walletPaymentAvailable"
                >
                </div>
                <div *ngIf="shouldCollectCustomerEmail">
                    <label
                        for="payment-customer-email"
                        class="form-label"
                    >
                        Email address
                    </label>
                    <input
                        id="payment-customer-email"
                        type="email"
                        autocomplete="email"
                        class="form-control"
                        data-test="payment-customer-email"
                        [formControl]="billingEmailAddressControl"
                        [attr.aria-invalid]="billingEmailAddressControl.invalid && billingEmailAddressControl.touched"
                        [attr.aria-describedby]="billingEmailAddressControl.invalid && billingEmailAddressControl.touched
                            ? 'payment-customer-email-error'
                            : null"
                        [class.is-invalid]="billingEmailAddressControl.invalid && billingEmailAddressControl.touched"
                    />
                    <div
                        id="payment-customer-email-error"
                        class="invalid-feedback"
                    >
                        Please enter a valid email address.
                    </div>
                </div>
                <p *ngIf="usesHostedCheckout" class="text-muted mb-0">
                    After continuing, you&rsquo;ll add your card details securely on Dojo.
                </p>
                <div
                    *ngIf="!usesHostedCheckout"
                    class="position-relative vstack justify-content-start justify-content-sm-center"
                    style="min-height: 150px; transition: none;"
                >
                    <div id="payment-card-form"></div>
                    <div
                        id="payment-card-form-spinner"
                        class="align-self-center position-absolute"
                        style="margin-top: -10px;"
                    >
                        <div class="spinner-border" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
                <div
                    *ngIf="usesHostedCheckout || requiresFutureChargeConsent"
                    class="form-check"
                    data-test="merchant-initiated-transaction-consent"
                >
                    <input
                        id="merchant-initiated-transaction-consent"
                        type="checkbox"
                        class="form-check-input"
                        [formControl]="merchantInitiatedTransactionConsentControl"
                        required
                    />
                    <label
                        class="form-check-label"
                        for="merchant-initiated-transaction-consent"
                    >
                        I consent to one cancellation or no-show charge of up to
                        <strong>{{ fullCancellationChargeAmount }}</strong>
                        being taken from this card under the policy above.
                    </label>
                </div>
            </div>
        </div>
        <div class="vstack justify-content-end">
            <div class="hstack gap-2">
                <button
                    *ngIf="showBackButton"
                    type="button"
                    class="btn btn-secondary w-auto"
                    (click)="onBackSelected()"
                >
                    Back
                </button>
                <div
                    *ngIf="showBackButton"
                    class="flex-grow-1 ms-auto me-auto"
                >
                </div>
                <button
                    type="button"
                    class="btn btn-primary"
                    [ngClass]="showBackButton ? 'w-auto' : 'flex-grow-1'"
                    [disabled]="isSaving || !paymentFormIsReady || ((usesHostedCheckout || requiresFutureChargeConsent) && merchantInitiatedTransactionConsentControl.invalid)"
                    (click)="onBookSelected()"
                >
                    Continue
                </button>
            </div>
        </div>
    </form>
</app-spinner-overlay>
